import React, { useContext } from 'react';
import ConfigContext from '../../../contexts/ConfigContext';
import Triple from './Triple';

import styles from './Triple.module.postcss';

function HowItWorks({ title, className, text1, text2, text3, title1, title2, title3 }) {
  const { vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  return (
    <section className={className || 'Section--extraPadding'}>
      <h3 className='u-phosphate u-mb2'>{title || 'How It Works'}</h3>
      <div className={styles.Triple_wrapper}>
        <Triple
          image='https://static.seattlefoodtruck.com/photos/howitworks1.webp'
          title={title1 || '1. Answer a few questions'}
          text={text1 || `Tell us more about your upcoming event and food ${vehicleType} needs.`}
        />
        <Triple
          image='https://static.seattlefoodtruck.com/photos/howitworks2.webp'
          title={title2 || '2. Receive quotes'}
          text={text2 || `Get quotes from available food ${vehicleType}s based on your event and budget.`}
        />
        <Triple
          image='https://static.seattlefoodtruck.com/photos/howitworks3.webp'
          title={title3 || `3. Book your ${vehicleType}`}
          text={text3 || `Compare quotes, message food ${vehicleType}s directly, and book the ones you like best.`}
        />
      </div>
    </section>
  );
}

export default HowItWorks;
